import React, {Component} from "react"
import PropTypes from "prop-types"
import {connect} from "react-redux"
import {loadRaces} from "../actions/online"
import {defaultState} from "../reducers/paginate"
import Races from "../components/Races";

class RacesPage extends Component {

	componentWillMount() {
		const {params} = this.props;
		if (params.seasonId) {
			this.props.loadRaces({seasonId: params.seasonId});
		}
	}

	componentWillReceiveProps(nextProps) {
	}

	componentWillUnmount() {
	}

	render() {
		const {params, seasonsPage, racesPage} = this.props;

		return (
			<div>
				<Races seasonId={params ? params.seasonId : null} seasons={seasonsPage} races={racesPage}/>
			</div>
		)
	}
}

RacesPage.propTypes = {
	racesPage: PropTypes.object,
	seasonsPage: PropTypes.object,
	enums: PropTypes.object,
	loadRaces: PropTypes.func.isRequired
};


const mapStateToProps = (state, ownProps) => {
	const {
		pagination: {races, seasons},
		enums,
	} = state;

	const racesPage = races[0] || defaultState;
	const seasonsPage = seasons[0] || defaultState;

	return {
		enums,
		seasonsPage,
		racesPage
	}
};

export default connect(mapStateToProps, {
	loadRaces
})(RacesPage)


// WEBPACK FOOTER //
// ./P:/Work/htdocs/biatlon/online/src/containers/RacesPage.js